(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-timer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shipping-timer')) {
    customElements.define(
      'shipping-timer',
      class ShippingTimer extends HTMLElement {
        connectedCallback() {
          if (this.updateInterval) return;

          this.cutoffHour = this.numberValue('cutoffHour', 20, 0, 23);
          this.cutoffMinute = this.numberValue('cutoffMinute', 0, 0, 59);
          this.deliveryMin = this.numberValue('deliveryMin', 2, 1, 30);
          this.deliveryMax = Math.max(
            this.deliveryMin,
            this.numberValue('deliveryMax', 4, 1, 30)
          );
          this.weekdaysOnly = this.dataset.weekdaysOnly === 'true';
          this.locale = this.dataset.locale || document.documentElement.lang || 'de-DE';
          this.timeZone = this.validTimeZone(this.dataset.timeZone);
          this.render();
          this.updateInterval = window.setInterval(() => this.render(), 30000);
        }

        disconnectedCallback() {
          window.clearInterval(this.updateInterval);
          this.updateInterval = null;
        }

        numberValue(key, fallback, minimum, maximum) {
          const value = Number.parseInt(this.dataset[key], 10);
          if (!Number.isFinite(value)) return fallback;
          return Math.min(maximum, Math.max(minimum, value));
        }

        validTimeZone(value) {
          const fallback = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
          if (!value) return fallback;

          try {
            new Intl.DateTimeFormat('de-DE', { timeZone: value }).format();
            return value;
          } catch (error) {
            return fallback;
          }
        }

        zonedParts(date) {
          const formatter = new Intl.DateTimeFormat('en-CA', {
            timeZone: this.timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
          });
          const parts = Object.fromEntries(
            formatter
              .formatToParts(date)
              .filter((part) => part.type !== 'literal')
              .map((part) => [part.type, Number(part.value)])
          );

          return {
            year: parts.year,
            month: parts.month,
            day: parts.day,
            hour: parts.hour,
            minute: parts.minute,
            second: parts.second
          };
        }

        zonedDateToUtc(parts, hour, minute) {
          const wanted = Date.UTC(parts.year, parts.month - 1, parts.day, hour, minute, 0);
          let guess = wanted;

          for (let index = 0; index < 3; index += 1) {
            const actual = this.zonedParts(new Date(guess));
            const actualAsUtc = Date.UTC(
              actual.year,
              actual.month - 1,
              actual.day,
              actual.hour,
              actual.minute,
              actual.second
            );
            guess += wanted - actualAsUtc;
          }

          return new Date(guess);
        }

        addCalendarDays(parts, amount) {
          const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
          date.setUTCDate(date.getUTCDate() + amount);
          return {
            year: date.getUTCFullYear(),
            month: date.getUTCMonth() + 1,
            day: date.getUTCDate()
          };
        }

        isWeekend(parts) {
          const day = new Date(Date.UTC(parts.year, parts.month - 1, parts.day)).getUTCDay();
          return day === 0 || day === 6;
        }

        addDeliveryDays(parts, amount) {
          let result = { ...parts };
          let added = 0;

          while (added < amount) {
            result = this.addCalendarDays(result, 1);
            if (!this.weekdaysOnly || !this.isWeekend(result)) added += 1;
          }

          return result;
        }

        sameDate(first, second) {
          return (
            first.year === second.year &&
            first.month === second.month &&
            first.day === second.day
          );
        }

        dateObject(parts) {
          return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
        }

        isoDate(parts) {
          const month = String(parts.month).padStart(2, '0');
          const day = String(parts.day).padStart(2, '0');
          return `${parts.year}-${month}-${day}`;
        }

        shortDate(parts) {
          return new Intl.DateTimeFormat(this.locale, {
            weekday: 'short',
            day: '2-digit',
            month: 'short',
            timeZone: 'UTC'
          }).format(this.dateObject(parts));
        }

        dateRange(first, second) {
          const formatter = new Intl.DateTimeFormat(this.locale, {
            day: '2-digit',
            month: 'short',
            timeZone: 'UTC'
          });
          const firstDate = this.dateObject(first);
          const secondDate = this.dateObject(second);

          if (typeof formatter.formatRange === 'function') {
            return formatter.formatRange(firstDate, secondDate);
          }

          return `${formatter.format(firstDate)} – ${formatter.format(secondDate)}`;
        }

        shipDateAndCutoff(now, today) {
          const todayCutoff = this.zonedDateToUtc(today, this.cutoffHour, this.cutoffMinute);
          const todayIsAvailable = !this.weekdaysOnly || !this.isWeekend(today);

          if (todayIsAvailable && now.getTime() < todayCutoff.getTime()) {
            return { shipDate: today, cutoff: todayCutoff };
          }

          let shipDate = this.addCalendarDays(today, 1);
          while (this.weekdaysOnly && this.isWeekend(shipDate)) {
            shipDate = this.addCalendarDays(shipDate, 1);
          }

          return {
            shipDate,
            cutoff: this.zonedDateToUtc(shipDate, this.cutoffHour, this.cutoffMinute)
          };
        }

        renderHeading(countdownText) {
          const template = this.dataset.headingTemplate || 'Wenn Du innerhalb {timer} bestellst';
          const tokenPosition = template.indexOf('{timer}');
          const before = this.querySelector('[data-heading-before]');
          const countdown = this.querySelector('[data-countdown]');
          const after = this.querySelector('[data-heading-after]');

          if (tokenPosition === -1) {
            before.textContent = `${template.trim()} `;
            after.textContent = '';
          } else {
            before.textContent = `${template.slice(0, tokenPosition).trim()} `;
            after.textContent = ` ${template.slice(tokenPosition + 7).trim()}`;
          }
          countdown.textContent = countdownText;
        }

        render() {
          const now = new Date();
          const today = this.zonedParts(now);
          const tomorrow = this.addCalendarDays(today, 1);
          const schedule = this.shipDateAndCutoff(now, today);
          const remainingMinutes = Math.max(
            0,
            Math.ceil((schedule.cutoff.getTime() - now.getTime()) / 60000)
          );
          const hours = Math.floor(remainingMinutes / 60);
          const minutes = String(remainingMinutes % 60).padStart(2, '0');
          const countdownText = `${hours} Std. ${minutes} Min.`;
          const deliveryStart = this.addDeliveryDays(schedule.shipDate, this.deliveryMin);
          const deliveryEnd = this.addDeliveryDays(schedule.shipDate, this.deliveryMax);
          const orderDate = this.querySelector('[data-order-date]');
          const shipDate = this.querySelector('[data-ship-date]');
          const deliveryDate = this.querySelector('[data-delivery-date]');
          const infoText = this.querySelector('[data-info-text]');

          this.renderHeading(countdownText);
          orderDate.textContent = this.dataset.todayText || 'Heute';
          orderDate.setAttribute('datetime', this.isoDate(today));

          if (this.sameDate(schedule.shipDate, today)) {
            shipDate.textContent = this.dataset.todayText || 'Heute';
          } else if (this.sameDate(schedule.shipDate, tomorrow)) {
            shipDate.textContent = this.dataset.tomorrowText || 'Morgen';
          } else {
            shipDate.textContent = this.shortDate(schedule.shipDate);
          }
          shipDate.setAttribute('datetime', this.isoDate(schedule.shipDate));
          deliveryDate.textContent = this.dateRange(deliveryStart, deliveryEnd);

          if (infoText) {
            const cutoff = `${String(this.cutoffHour).padStart(2, '0')}:${String(
              this.cutoffMinute
            ).padStart(2, '0')}`;
            infoText.textContent = (this.dataset.infoTemplate || '')
              .replaceAll('{cutoff}', cutoff)
              .replaceAll('{min}', String(this.deliveryMin))
              .replaceAll('{max}', String(this.deliveryMax));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
